import { render, staticRenderFns } from "./AndroidSdk.vue?vue&type=template&id=adb0d16a&scoped=true"
import script from "./AndroidSdk.vue?vue&type=script&lang=ts"
export * from "./AndroidSdk.vue?vue&type=script&lang=ts"
import style0 from "./AndroidSdk.vue?vue&type=style&index=0&id=adb0d16a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb0d16a",
  null
  
)

export default component.exports